import React, { useEffect, useState } from "react";
import { Link, useLoaderData } from "react-router-dom";

const MiraiCategoryCareer = () => {
  const { category } = useLoaderData(); // Destructure category directly
  const [news, setNews] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const limit = 2; // Display 2 items per page

  useEffect(() => {
    setCurrentPage(1); // Reset to first page when category changes
  }, [category]);

  useEffect(() => {
    fetchNews(); // Fetch news whenever category or currentPage changes
  }, [category, currentPage]);

  const fetchNews = async () => {
    setLoading(true); // Start loading
    try {
      const response = await fetch(
        `https://mirai-server.vercel.app/news-column/${category}?page=${currentPage}&limit=${limit}`
      );
      const data = await response.json();

      if (response.ok) {
        setNews(data.result || []); // Update news
        setTotalPages(data.totalPages || 1); // Update total pages
      } else {
        console.error("Error fetching news:", data.message);
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setLoading(false); // End loading
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
    }
  };
  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to the top of the page when component mounts
  }, []);
  return (
    <div className="text-justify lg:py-20 sm:py-5 min-h-screen border-t border-blue-200">
      <div className="text-justify w-full max-w-screen-2xl mx-auto p-4">
        <h1 className="text-justify lg:text-5xl sm:text-2xl font-semibold font-jost customBlue">
          {category.charAt(0).toUpperCase() + category.slice(1)}
        </h1>
        <div className="text-justify w-full lg:mt-10 sm:mt-5"></div>
        {loading ? (
          <p>Loading...</p> // Show loading indicator
        ) : (
          <div>
            {news.map((item, index) => (
              <Link to={`/news-details/${item._id}`} key={index}>
                <div>
                  <h1 className="text-justify lg:text-xl sm:text-md flex lg:flex-row sm:flex-col justify-between font-semibold font-jost text-blue-900 w-full hover:bg-blue-100 lg:hover:px-6 sm:hover:px-4 duration-300 ease-in-out lg:py-6 sm:py-4 border-b border-blue-500">
                    {item.title}
                    <span className="text-justify text-sm font-normal font-jost text-blue-500">
                      Posted Date: {new Date(item.createdAt).toDateString()}
                    </span>
                  </h1>
                </div>
              </Link>
            ))}
          </div>
        )}

        {/* Pagination Controls */}

        <div className="text-justify flex justify-end mt-6">
          <button
            onClick={handlePreviousPage}
            disabled={currentPage === 1}
            className="text-justify px-4 py-2  bg-blue-500 font-jost text-sm text-white rounded disabled:opacity-50"
          >
            Previous
          </button>
          <span className="text-justify px-4 py-2  font-jost text-sm bg-blue-50">
            Page {currentPage} of {totalPages}
          </span>
          <button
            onClick={handleNextPage}
            disabled={currentPage === totalPages}
            className="text-justify px-4 py-2  bg-blue-500 font-jost text-sm text-white rounded disabled:opacity-50"
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default MiraiCategoryCareer;
